import React from 'react';

// OneTrust global declarations
declare global {
  interface Window {
    OneTrust?: {
      syncConsentProfile: (userId: string, jwtToken: string | null, isAnonymous: boolean) => void;
      changeLanguage: (lang: string) => void;
      getGeolocationData: () => { country: string; state?: string };
    };
  }
}

/**
 * A singleton wrapper around OneTrust consent management
 */
class FiOneTrust {
  public isAvailable(): boolean {
    try {
      return typeof window !== 'undefined' && !!window.OneTrust;
    } catch (err) {
      console.error('Error checking OneTrust availability:', err);
      return false;
    }
  }

  public syncConsentProfile(userId: string, jwtToken: string | null, isAnonymous: boolean): void {
    try {
      if (!this.isAvailable()) {
        console.warn('OneTrust is not available. Skipping consent profile sync.');
        return;
      }

      window.OneTrust!.syncConsentProfile(userId, jwtToken, isAnonymous);
    } catch (err) {
      console.error('Error syncing OneTrust consent profile:', err);
    }
  }

  public syncUserConsentProfile(userId: string, jwtToken: string): void {
    this.syncConsentProfile(userId, jwtToken, false);
  }

  public syncAnonymousConsentProfile(anonymousId?: string): void {
    const anonId = anonymousId || this.generateAnonymousId();
    this.syncConsentProfile(anonId, null, true);
  }

  private generateAnonymousId(): string {
    return `anon-${crypto.randomUUID()}`;
  }
}

const fiOneTrust = new FiOneTrust();

export function getFiOneTrust(): FiOneTrust {
  return fiOneTrust;
}

export function HideCookieConsentBanner() {
  return (
    <style
      type="text/css"
      dangerouslySetInnerHTML={{
        __html: `
          #onetrust-consent-sdk {
            display: none !important;
          }
        `,
      }}
    />
  );
}

export default fiOneTrust;
